import React, { useState, useEffect } from 'react';

/* ── Time-of-day greeting ──────────────────────────────────── */
function getGreeting() {
  const h = new Date().getHours();
  if (h >= 5  && h < 12) return { text: 'Good Morning',   icon: '🌅', color: 'text-yellow-400' };
  if (h >= 12 && h < 17) return { text: 'Good Afternoon', icon: '☀️',  color: 'text-orange-400' };
  if (h >= 17 && h < 21) return { text: 'Good Evening',   icon: '🌆', color: 'text-purple-400' };
  return                         { text: 'Good Night',     icon: '🌙', color: 'text-blue-300'   };
}

const Footer = () => {
  const [greeting, setGreeting] = useState(getGreeting());
  const [time, setTime]         = useState(new Date());
  const year                    = new Date().getFullYear();

  /* Update clock + greeting every minute */
  useEffect(() => {
    const id = setInterval(() => {
      setTime(new Date());
      setGreeting(getGreeting());
    }, 60_000);
    return () => clearInterval(id);
  }, []);

  const fmt = time.toLocaleTimeString('en-US', {
    hour: '2-digit', minute: '2-digit', hour12: true,
  });

  return (
    <footer className="bg-whatsapp-darker border-t border-green-900/50 pb-safe">
      <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">

        {/* Greeting + clock */}
        <div className={`flex items-center gap-2 text-xs sm:text-sm font-medium ${greeting.color}`}>
          <span className="text-base">{greeting.icon}</span>
          <span>{greeting.text}!</span>
          <span className="text-green-400/60">·</span>
          <span className="text-green-300 tabular-nums">{fmt}</span>
        </div>

        {/* Developer credit */}
        <p className="text-green-300/70 text-xs">
          Developed by{' '}
          <span className="text-whatsapp-green font-bold">Jean Paul</span>
          {' '}to My classmate —{' '}
          <span className="text-pink-400 font-semibold">I love You Too</span>
          {' '}❤️{' · '}
          <span className="text-green-400/50">{year}</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
